import Simple from "../../../Components/InputFields/Simple";
import GradientBlue from "../../../Components/InputFields/GradientBlue";
import LogoWhite10 from "../../../Media/PNG/LogoWhite10.svg";
import LogoBlue from "../../../Media/PNG/LogoBlue.svg";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getRedirectFromNext } from "../../../helper/nextRedirect";
import Back from "./Back";
import Input from "./Input";
import { API_BASE_URL } from "../../../config/api";

const DEFAULT_SIGNUP_DATA = {
  phone_number: "",
  fn: "",
  ln: "",
};

function omitFalsyFields(payload) {
  return Object.fromEntries(
    Object.entries(payload).filter(([, value]) => Boolean(value)),
  );
}

export default function ContainerSignUpInfo({
  text,
  subtext,
  signupData,
  setSignupData,
  setStep,
}) {
  const [isDark] = useState(
    typeof document !== "undefined" &&
      document.documentElement.classList.contains("dark"),
  );
  const logoSrc = isDark ? LogoWhite10 : LogoBlue;
  const [localSignupData, setLocalSignupData] = useState(DEFAULT_SIGNUP_DATA);
  const formData = signupData || localSignupData;
  const updateSignupData = setSignupData || setLocalSignupData;
  const navigate = useNavigate();
  const { search } = useLocation();
  const nextParam = new URLSearchParams(search).get("next");
  const redirectFromNext = getRedirectFromNext(nextParam);
  const signinPath = nextParam
    ? `/signin/email?next=${encodeURIComponent(nextParam)}`
    : "/signin/email";
  const [fieldsRequired, setFieldsRequired] = useState(false);
  const [invalidPhoneNumber, setInvalidPhoneNumber] = useState(false);
  const [phoneOld, setPhoneOld] = useState(false);
  const [signupNotOkay, setSignupNotOkay] = useState(false);

  const [loading, setLoading] = useState(false);
  const [passLoading, setPassLoading] = useState(false)


  useEffect(() => {
    if (redirectFromNext) {
      localStorage.setItem("post_login_redirect", redirectFromNext);
    }
  }, [redirectFromNext]);

  const handlePhoneChange = (e) => {
    updateSignupData((previousData) => ({
      ...DEFAULT_SIGNUP_DATA,
      ...previousData,
      phone_number: e.target.value,
    }));
    setFieldsRequired(false);
    setInvalidPhoneNumber(false);
    setPhoneOld(false);
  };
  const handleFnChange = (e) => {
    updateSignupData((previousData) => ({
      ...DEFAULT_SIGNUP_DATA,
      ...previousData,
      fn: e.target.value,
    }));
    setFieldsRequired(false);
  };
  const handleLnChange = (e) => {
    updateSignupData((previousData) => ({
      ...DEFAULT_SIGNUP_DATA,
      ...previousData,
      ln: e.target.value,
    }));
    setFieldsRequired(false);
  };

  const handleSignin = async (e) => {
    e.preventDefault();
    const phoneNumber = (formData.phone_number || "").trim();
    const trimmedFn = (formData.fn || "").trim();
    const trimmedLn = (formData.ln || "").trim();
    const { referal_code, ...formDataWithoutTypo } = formData;
    const signupPayload = {
      ...formDataWithoutTypo,
      phone_number: phoneNumber,
      fn: trimmedFn,
      ln: trimmedLn,
      referral_code: (formData.referral_code || referal_code || "").trim(),
    };
    const requestPayload = omitFalsyFields(signupPayload);

    updateSignupData((previousData) => ({ ...previousData, ...signupPayload }));

    if (!phoneNumber || !trimmedFn || !trimmedLn) {
      setFieldsRequired(true);
      return;
    }

    setFieldsRequired(false);

    const phoneRegex = /^09\d{9}$/;
    if (!phoneRegex.test(phoneNumber)) {
      setInvalidPhoneNumber(true);
      return;
    }

    setInvalidPhoneNumber(false);
    setPhoneOld(false);
    setSignupNotOkay(false);
    setLoading(true);
    setPassLoading(false)
    try {
      const phoneResponse = await fetch(
        `${API_BASE_URL}auth/trader/signup/request-phone-otp/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            phone_number: phoneNumber,
          }),
        },
      );

      const phoneResult = await phoneResponse.json();

      if (
        phoneResult.status === "failure" &&
        phoneResult.message === "Phone number already exists."
      ) {
        setPhoneOld(true);
        setLoading(false);
        return;
      }

      if (!phoneResponse.ok) {
        throw new Error(`https error! Status: ${phoneResponse.status}`);
      }

      let response = await fetch(
        `${API_BASE_URL}auth/trader/signup/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestPayload),
        },
      );

      // Now handle final response (either first or retried)
      if (!response.ok) {
        setSignupNotOkay(true);
        throw new Error(`https error! Status: ${response.status}`);
      }

      const data = await response.json().catch(() => null);
      console.log("Account Data:", data);
      setLoading(false);
      setPassLoading(true)
      setTimeout(() => navigate(signinPath),3000)
      
    } catch (error) {
      console.error("Error fetching account data:", error);
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-sm bg-zi-bg2-light dark:bg-zi-inputbg-dark/50 rounded-3xl p-5 gap-7 flex flex-col">
      <div className="flex flex-col gap-2 justify-center items-center">
        <div className="h-14">
          <img src={logoSrc} alt="لوگو" className="w-14" />
        </div>
        <p className="font-medium text-sm text-zi-text-light dark:text-zi-text-dark">
          کوژیتو فاند
        </p>
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex justify-between items-center">
          <h1 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
            {text}
          </h1>
          <Back onClick={() => setStep && setStep(2)} />
        </div>
        <span className="text-xs font-light text-zi-text-light/50 dark:text-zi-text-dark/50">
          {subtext}
        </span>
      </div>
      <div>
        <form className="flex flex-col gap-5" onSubmit={handleSignin}>
          <Simple
            placeholder="شماره تلفن همراه"
            type="tel"
            id="phoneNumber"
            isNumeric={true}
            formValue={formData.phone_number}
            formOnChange={handlePhoneChange}
          />
          <Input
            label="نام"
            value={formData.fn || ""}
            type="text"
            id="fn"
            name="fn"
            isReadOnly={false}
            isAuotComplete={true}
            onChange={handleFnChange}
          />
          <Input
            label="نام خانوادگی"
            value={formData.ln || ""}
            type="text"
            id="ln"
            name="ln"
            isReadOnly={false}
            isAuotComplete={true}
            onChange={handleLnChange}
          />
          {!loading && !passLoading ? (
            <GradientBlue
              type="submit"
              value="ایجاد"
              onClick={handleSignin}
            />
          ) : loading && !passLoading ?(
            <GradientBlue
              type="submit"
              isLoader={true}
              onClick={() => {}}
            />
          ) : <GradientBlue
              type="submit"
              haveLottie={true}
              onClick={() => {}}
            />}
        </form>
        {fieldsRequired && (
          <p className="text-amber-400 text-sm font-extralight mt-1">
            لطفا شماره همراه، نام و نام خانوادگی را وارد کنید
          </p>
        )}
        {invalidPhoneNumber && (
          <p className="text-amber-400 text-sm font-extralight mt-1">
            شماره تلفن همراه وارد شده معتبر نیست
          </p>
        )}
        {phoneOld && (
          <p className="text-amber-400 text-sm font-extralight mt-1">
            این شماره تلفن همراه قبلا ثبت نام شده است
          </p>
        )}
        {signupNotOkay && (
          <p className="text-amber-400 text-sm font-extralight mt-1">
            ثبت نام انجام نشد. لطفاً دوباره تلاش کنید.
          </p>
        )}
      </div>
    </div>
  );
}
